// extracted by mini-css-extract-plugin
export default {"productCallout":"Qaa-z"};